// This file should collate user_typing events and update the redux state as necessary
import GeckoSocket from 'services/gecko-socket';
import GeckoStore from 'services/gecko-store';

let state = {
  typing_status: {},
  users: [],
};

GeckoSocket.on('user_typing', ({ user_id, conversation_id, timestamp }) => {
  if (user_id === GeckoStore.redux.get('appState.loggedInUser.id')) {
    return;
  }
  const user = state.users.find((u) => Number(u.id) === Number(user_id));
  if (!user) {
    return;
  }
  const userToStore = Object.assign({}, user, { timestamp });
  GeckoStore.redux.dispatch({
    type: 'ADD_TYPING_STATUS',
    payload: { conversation_id, user: userToStore },
  });
});

GeckoStore.redux.store.subscribe(() => {
  state.typing_status = GeckoStore.redux.get('typing_status');
  const agents = GeckoStore.redux.get('agents');
  const contactsById = GeckoStore.redux.get('conversationsRoute.contactsById');
  const contacts = Object.keys(contactsById).map((key) => contactsById[key]);
  state.users = [].concat(agents, contacts);
});

const expireTime = 1000;
const cleanUpLoop = () => {
  Object.keys(state.typing_status).forEach((conversation_id) => {
    const users = state.typing_status[conversation_id];
    const expiredUsers = users.filter(
      (u) => Date.now() - u.timestamp > expireTime
    );
    expiredUsers.forEach((user) =>
      GeckoStore.redux.dispatch({
        type: 'REMOVE_TYPING_STATUS',
        payload: { conversation_id, user },
      })
    );
  });
  setTimeout(cleanUpLoop, 1000);
};
cleanUpLoop();
